export const QUESTION_CODES = ['DIVERSIFICATION'] as const;
export type IQuestionCode = (typeof QUESTION_CODES)[number];

export type IScopeType = 'ALL_PORTFOLIOS' | 'PORTFOLIO';

export const RESPONSE_STAGES = ['LOADING_DATA', 'GENERATING_RESPONSE', 'VALIDATING_RESPONSE'] as const;
export type IResponseStage = (typeof RESPONSE_STAGES)[number];

export const RESPONSE_ERROR_CODES = ['AI_ANALYSIS_FAILED', 'AI_SESSION_NOT_AVAILABLE', 'ANALYSIS_NOT_AVAILABLE'] as const;
export type IResponseErrorCode = (typeof RESPONSE_ERROR_CODES)[number];

export interface AiInvestmentAnalysisRequest {
  readonly questionCode: IQuestionCode;
  readonly scopeType: IScopeType;
  readonly portfolioId?: string;
  readonly sessionId?: string;
}

// todo - based on chart in figma cleanup and best merge these types with existing charts
export interface INamedValue {
  readonly name: string;
  readonly value: number;
}

export interface ITreemapChartData {
  readonly nodes: readonly INamedValue[];
}

export interface IGroupedBarSeries {
  readonly name: string;
  readonly values: readonly number[];
}

export interface IGroupedBarChartData {
  readonly categories: readonly string[];
  readonly series: readonly IGroupedBarSeries[];
}

export interface IPieChartData {
  readonly slices: readonly INamedValue[];
}

export type IChartPayload =
  | { readonly suggestedType: 'TREEMAP'; readonly data: ITreemapChartData }
  | { readonly suggestedType: 'GROUPED_BAR'; readonly data: IGroupedBarChartData }
  | { readonly suggestedType: 'PIE'; readonly data: IPieChartData };

export type IAnalysisChart = {
  readonly chartId: string;
  readonly meaning: string | null;
  readonly title: string;
} & IChartPayload;

export type IAiInvestmentAnalysisEvent =
  | { readonly type: 'response.started'; readonly responseId: string | null; readonly sessionId: string }
  | { readonly type: 'response.update'; readonly stage: IResponseStage | null }
  | { readonly type: 'response.text'; readonly text: string }
  | { readonly type: 'response.chart'; readonly chart: IAnalysisChart }
  | { readonly type: 'response.completed'; readonly disclaimer: string }
  | { readonly type: 'response.failed'; readonly errorCode: IResponseErrorCode | null; readonly retryable: boolean };

export function isTerminalAnalysisEvent(event: IAiInvestmentAnalysisEvent): boolean {
  return event.type === 'response.completed' || event.type === 'response.failed';
}
